import { Link } from 'react-router-dom';
import { siteInfo, navLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold whitespace-nowrap">
              91网
            </Link>
            <p className="mt-3 text-sm text-background-50/70 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category/resources" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">学习资源</Link></li>
              <li><Link to="/category/tools" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">实用工具</Link></li>
              <li><Link to="/category/news" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">行业资讯</Link></li>
              <li><Link to="/category/life" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">生活服务</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-50/70">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/60">
            {siteInfo.copyright}
          </p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-sm text-background-50/60 hover:text-background-50/80 transition-colors whitespace-nowrap"
          >
            {siteInfo.beian}
          </a>
        </div>
      </div>
    </footer>
  );
}